/* Sezione Video UGC — iHeel / Symmetry (17/09/2026)
   - autoplay muto via IntersectionObserver (se abilitato nella sezione)
   - tap sul video = play/pausa; tasto audio = mute on/off (un solo video con audio alla volta)
   - frecce desktop scorrono di una card
*/
if (!customElements.get('ugc-videos')) {
  class UgcVideos extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.ugc-videos__track');
      this.cards = Array.from(this.querySelectorAll('.ugc-card'));
      this.autoplay = this.dataset.autoplay === 'true';
      this.prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.cards.forEach((card) => {
        const video = card.querySelector('video');
        if (!video) return;
        video.muted = true;
        video.setAttribute('muted', '');
        video.playsInline = true;
        card.querySelector('.ugc-card__play').addEventListener('click', () => this.togglePlay(card));
        card.querySelector('.ugc-card__sound').addEventListener('click', (e) => { e.stopPropagation(); this.toggleSound(card); });
        video.addEventListener('play', () => card.classList.add('is-playing'));
        video.addEventListener('pause', () => card.classList.remove('is-playing'));
      });

      if (this.autoplay && !this.prefersReduced && 'IntersectionObserver' in window) {
        this.io = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const video = entry.target.querySelector('video');
            if (!video) return;
            if (entry.isIntersecting) {
              if (entry.target.dataset.userPaused !== 'true') video.play().catch(() => {});
            } else {
              video.pause();
              if (!video.muted) this.setSound(entry.target, false);
            }
          });
        }, { threshold: 0.6 });
        this.cards.forEach((c) => this.io.observe(c));
      }

      this.prevBtn = this.querySelector('.ugc-videos__arrow--prev');
      this.nextBtn = this.querySelector('.ugc-videos__arrow--next');
      if (this.prevBtn && this.nextBtn) {
        this.prevBtn.addEventListener('click', () => this.scrollByCard(-1));
        this.nextBtn.addEventListener('click', () => this.scrollByCard(1));
        this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true });
        window.addEventListener('resize', () => this.updateLayout());
      }
      this.updateLayout();
    }

    disconnectedCallback() { if (this.io) this.io.disconnect(); }

    updateLayout() {
      // se tutte le card entrano nel viewport, centra la fila e nascondi le frecce
      const fits = this.track.scrollWidth <= this.track.clientWidth + 1;
      this.classList.toggle('ugc-videos--centered', fits);
      this.updateArrows();
    }

    updateArrows() {
      if (!this.prevBtn) return;
      const max = this.track.scrollWidth - this.track.clientWidth;
      this.prevBtn.disabled = this.track.scrollLeft <= 2;
      this.nextBtn.disabled = this.track.scrollLeft >= max - 2;
    }

    scrollByCard(dir) {
      const item = this.track.querySelector('.ugc-videos__item');
      if (!item) return;
      const gap = parseFloat(getComputedStyle(this.track).gap) || 16;
      this.track.scrollBy({ left: dir * (item.offsetWidth + gap), behavior: 'smooth' });
    }

    togglePlay(card) {
      const video = card.querySelector('video');
      if (video.paused) {
        card.dataset.userPaused = 'false';
        video.play().catch(() => {});
      } else {
        card.dataset.userPaused = 'true';
        video.pause();
      }
    }

    toggleSound(card) {
      const video = card.querySelector('video');
      this.setSound(card, video.muted);
    }

    setSound(card, on) {
      const video = card.querySelector('video');
      const btn = card.querySelector('.ugc-card__sound');
      if (on) {
        // un solo video con audio alla volta
        this.cards.forEach((c) => { if (c !== card) this.setSound(c, false); });
        video.muted = false;
        card.dataset.userPaused = 'false';
        if (video.paused) video.play().catch(() => {});
      } else {
        video.muted = true;
      }
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? 'Disattiva audio' : 'Attiva audio');
    }
  }
  customElements.define('ugc-videos', UgcVideos);
}
